export default function initReviewsCarousel() {
    // ==========================================================
    // SWIPER REVIEWS
    // ==========================================================
    const reviewsCarousels = document.querySelectorAll("[data-reviews-carousel]");

    reviewsCarousels.forEach((carousel) => {
        const cards = Array.from(carousel.querySelectorAll("[data-review-card]"));

        const prevButton = carousel.querySelector("[data-reviews-prev]");

        const nextButton = carousel.querySelector("[data-reviews-next]");

        const pagination = carousel.querySelector("[data-reviews-pagination]");

        if (!cards.length) {
            return;
        }

        let activeIndex = 0;

        const getPreviousIndex = () => {
            return (activeIndex - 1 + cards.length) % cards.length;
        };

        const getNextIndex = () => {
            return (activeIndex + 1) % cards.length;
        };

        const updateCarousel = () => {
            const previousIndex = getPreviousIndex();
            const nextIndex = getNextIndex();

            cards.forEach((card, index) => {
                card.classList.remove("is-active", "is-prev", "is-next");

                if (index === activeIndex) {
                    card.classList.add("is-active");
                }

                if (cards.length > 1 && index === previousIndex) {
                    card.classList.add("is-prev");
                }

                if (cards.length > 1 && index === nextIndex) {
                    card.classList.add("is-next");
                }
            });

            updatePagination();
        };

        const updatePagination = () => {
            if (!pagination) {
                return;
            }

            const bullets = pagination.querySelectorAll(".reviews-carousel__bullet");

            bullets.forEach((bullet, index) => {
                bullet.classList.toggle("is-active", index === activeIndex);
            });
        };

        const createPagination = () => {
            if (!pagination || cards.length <= 1) {
                return;
            }

            cards.forEach((card, index) => {
                const button = document.createElement("button");

                button.type = "button";

                button.className = "reviews-carousel__bullet";

                button.setAttribute("aria-label", `Aller à l’avis ${index + 1}`);

                button.addEventListener("click", () => {
                    activeIndex = index;
                    updateCarousel();
                });

                pagination.appendChild(button);
            });
        };

        prevButton?.addEventListener("click", () => {
            activeIndex = getPreviousIndex();

            updateCarousel();
        });

        nextButton?.addEventListener("click", () => {
            activeIndex = getNextIndex();

            updateCarousel();
        });

        createPagination();
        updateCarousel();
    });
}
